import { render, staticRenderFns } from "./TheApp.vue?vue&type=template&id=dac4ca3c&scoped=true&"
import script from "./TheApp.vue?vue&type=script&lang=js&"
export * from "./TheApp.vue?vue&type=script&lang=js&"
import style0 from "./TheApp.vue?vue&type=style&index=0&id=dac4ca3c&scoped=true&lang=css&"
import style1 from "./TheApp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac4ca3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dac4ca3c')) {
      api.createRecord('dac4ca3c', component.options)
    } else {
      api.reload('dac4ca3c', component.options)
    }
    module.hot.accept("./TheApp.vue?vue&type=template&id=dac4ca3c&scoped=true&", function () {
      api.rerender('dac4ca3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/TheApp.vue"
export default component.exports